import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { StorageService } from '@pulpo/pulpo-api';
import { RoleTypeEnum } from '@pulpo/pulpo-models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminAuthGuard implements CanActivateChild {
  constructor(
    private storageService: StorageService,
    private router: Router
  ) {}
  canActivateChild(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.isTechAdmin();
  }

  private isTechAdmin(): boolean {
    if (
      this.storageService.getSessionRoleType() === RoleTypeEnum.TECHNICAL_ADMIN
    ) {
      return true;
    }
    return this.redirectToLoginAndReturnFalse();
  }

  private redirectToLoginAndReturnFalse(): boolean {
    this.router.navigate(['/login']);

    return false;
  }
}
